import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Lottie from 'lottie-react';

import errorAnimation from '@/assets/error.json';
import loaderAnimation from '@/assets/loader.json';
import successAnimation from '@/assets/success.json';
import { PoweredByAppcharge } from '@/components/Footer/PoweredByAppcharge';
import { useOrderPolling } from '@/hooks/useOrderPolling';
import { useTranslate } from '@/hooks/useTranslate';
import { apiClient } from '@/services/apiClient';
import { PollingStatus } from '@/types/order';
import { getQueryParam } from '@/utils/queryParams';

const shouldAutoCloseWindow = getQueryParam('autoClose') === 'true';

if (shouldAutoCloseWindow) {
  window.close();
}

export const PaymentStatusPage = () => {
  const { sessionId, orderId } = useParams<{ sessionId: string; orderId: string }>();
  const { t } = useTranslate();
  const { triggerOrderPolling, statusOrderPolling } = useOrderPolling();

  useEffect(() => {
    if (!sessionId || !orderId) return;
    apiClient.initilize({ token: sessionId });
    triggerOrderPolling(orderId);
  }, [sessionId, orderId, triggerOrderPolling]);

  const isPaymentSucceeded =
    statusOrderPolling === PollingStatus.SUCCESS ? true : statusOrderPolling === PollingStatus.FAILED ? false : null;

  return (
    <div className="fixed inset-0 z-[99999] flex h-dvh w-screen flex-col items-center justify-center overflow-hidden bg-white text-center">
      <div className="relative">
        {isPaymentSucceeded !== null ? (
          <>
            <div className="absolute bottom-[60px] left-0 right-0 flex justify-center">
              <Lottie
                animationData={isPaymentSucceeded ? successAnimation : errorAnimation}
                style={{ height: 160 }}
                loop={false}
              />
            </div>
            <h3 className="m-0 text-[28px]">{isPaymentSucceeded ? 'Payment Successful!' : 'Payment Failed'}</h3>
            <h2 className="m-0 pt-2 text-base font-medium">{t('continueOnDesktop')}</h2>
          </>
        ) : (
          <Lottie animationData={loaderAnimation} style={{ height: 160 }} loop />
        )}
      </div>
      <div className="absolute bottom-6">
        <PoweredByAppcharge />
      </div>
    </div>
  );
};
